var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270.54 270.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.67,
    y: 8.66,
    width: 253.21,
    height: 253.21,
    rx: 126.6,
    fill: "#ef6f6f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.3,270.51C61.32,272.2-1.65,209.23,0,132.25,1.61,60.22,60.17,1.64,132.2,0c77-1.71,140,61.3,138.3,138.31C268.9,210.37,210.33,268.93,138.3,270.51Zm.88-253.11A118.05,118.05,0,0,0,17.4,139.19c2,61.8,52.16,112,114,114a118.06,118.06,0,0,0,121.78-121.8C251.13,69.55,201,19.4,139.18,17.4Z",
    fill: "#c63838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.44,151.65v4.4q0,11.67-11,11.67H69.51q-11,0-11-11.67V110.71q0-11.68,11-11.68h5.93q11,0,11,11.68v7.74H77.26v-7.07q0-4-4.11-4H71.33q-3.64,0-3.64,4v44q0,4,3.64,4h2.29c2.42,0,3.64-1.34,3.64-4v-3.73Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.43,167.72H93.61V99h9.19V159.4h12.63Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.68,167.72V99h22.77v8.33H129.87v20.85h12v8.32h-12V159.4h13.58v8.32Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.75,167.72h-9.18V110.8q0-11.76,11-11.77h6.89q11,0,11,11.77v56.92h-9.18V142.56H158.75Zm10.53-33.48V111.38q0-4-4-4h-2.49q-4,0-4,4v22.86Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.59,99h18q10.53,0,10.53,11.77v16.93q0,9-5.46,11.39l6.42,28.6h-8.71l-6-27.74h-5.54v27.74h-9.19Zm9.19,33.1h6c2.74,0,4.11-1.65,4.11-5V112.33q0-5-4.11-5h-6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearButton);
export default __webpack_public_path__ + "static/media/clear-button.fc1236a7e51ce0c9b6d04c3cbd98132c.svg";
export { ForwardRef as ReactComponent };